/**
 * GIWAHS — Supabase Client (lazy-initialised)
 * ---------------------------------------------------------------------
 * Returns a Supabase client only when both env vars are present.
 * Otherwise returns null and the data layer falls back to mock mode.
 *
 * The dataClient (./dataClient.js) is the only consumer — components
 * should never import this file directly.
 */
import { createClient } from '@supabase/supabase-js';

const URL  = process.env.REACT_APP_SUPABASE_URL;
const KEY  = process.env.REACT_APP_SUPABASE_ANON_KEY;

let cached = undefined; // undefined = not yet checked

export const getSupabaseClient = () => {
  if (cached !== undefined) return cached;
  if (URL && KEY && URL.startsWith('http')) {
    cached = createClient(URL, KEY, {
      auth: { persistSession: true, autoRefreshToken: true },
      db: { schema: 'public' },
    });
  } else {
    cached = null;
  }
  return cached;
};

export const isSupabaseConfigured = () => Boolean(URL && KEY && URL.startsWith('http'));
